module.exports = __webpack_public_path__ + "static/media/6 4th RAC_Minutes of Meeting 2023.ab941df3.pdf";